import { Pages, Routes } from "./enums";

export function appPath(...segments: string[]): string {
  const parts = segments.filter(Boolean);
  return parts.length === 0 ? "/" : `/${parts.join("/")}`;
}

const authBase = `/${Routes.AUTH}`;

export const AUTH_PATHS = {
  LOGIN: `${authBase}/${Pages.LOGIN}`,
  ENTER_OTP: `${authBase}/${Pages.ENTER_OTP}`,
  FORGOT_PASSWORD: `${authBase}/${Pages.FORGOT_PASSWORD}`,
  FORGOT_PASSWORD_SENT: `${authBase}/${Pages.FORGOT_PASSWORD}/sent`,
  RESET_PASSWORD: `${authBase}/${Pages.RESET_PASSWORD}`,
  SET_PASSWORD: `${authBase}/${Pages.SET_PASSWORD}`,
  REQUIRED_PASSWORD_CHANGE: `${authBase}/${Pages.REQUIRED_PASSWORD_CHANGE}`,
} as const;
